import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, History, Calendar } from 'lucide-angular';
import { ModalDataService } from '../../../../core/services/modal-data.service';
import { ModalService } from '../../../../core/services/modal.service';
import { MedicalRecordService } from '../../../../core/services/medical-record.service';
import { HealthCondition } from '../../../../core/interfaces/health-condition.interface';

@Component({
  selector: 'app-comorbidity-history-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './comorbidity-history-modal.component.html',
})
export class ComorbidityHistoryModalComponent implements OnInit {
  readonly History = History;
  readonly Calendar = Calendar;

  condition: HealthCondition | null = null;
  patientName: string = 'Patient';
  history: HealthCondition[] = [];
  loading = true;
  error: string | null = null;

  constructor(
    private modalService: ModalService,
    private medicalRecordService: MedicalRecordService
  ) {}

  ngOnInit(): void {
    const data = ModalDataService.getData();
    if (data?.condition) {
      this.condition = data.condition;
      this.patientName = data.patientName || 'Patient';
      this.loadHistory();
    } else {
      this.error = 'Aucune comorbidité sélectionnée';
      this.loading = false;
    }
  }

  private loadHistory(): void {
    if (!this.condition?._id) {
      this.loading = false;
      return;
    }

    this.medicalRecordService.getHealthConditionHistory(this.condition._id).subscribe({
      next: (response) => {
        this.history = Array.isArray(response) ? response : (response as any)?.data ?? [];
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.error?.message || 'Erreur lors du chargement de l\'historique';
        this.history = [];
        this.loading = false;
      },
    });
  }

  closeModal(): void {
    this.modalService.closeAll();
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  getStatusLabel(status: string | undefined): string {
    if (!status) return '—';
    if (status === 'active') return 'OUI';
    if (status === 'unknown') return 'NON FAIT';
    return 'NON';
  }

  /**
   * Retourne l'auteur de la version de la comorbidité/antécédent.
   * Si 'eyoneSyncDate' est présent, c'est le médecin.
   * Sinon c'est le patient (nom reçu en entrée).
   */
  getAuthor(item: HealthCondition): string {
    if (item.eyoneSyncDate) {
      return 'Médecin';
    }
    return this.patientName;
  }
}
